module.exports = __webpack_public_path__ + "img/arrow-down-blue.41b47a7e.svg";